















import { Component, Prop, Vue } from "vue-property-decorator";
import ArrowIcon from "@/assets/icons/emoco_pil_web.svg";
import Icon from "../Icon.vue";
import TextLink from "../TextLink.vue";

@Component({
  components: {
    ArrowIcon,
    Icon,
    TextLink,
  },
})
export default class CookieBanner extends Vue {
  @Prop() onClick!: () => void;

  scrollUp() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
